var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1705 4.47079C15.9835 3.46536 18.2898 4.12596 19.303 5.92279L28.9947 22.743C29.208 23.245 29.3013 23.6533 29.3279 24.0774C29.3813 25.0683 29.0347 26.0314 28.3548 26.7726C27.6749 27.5112 26.755 27.9472 25.7552 28H6.2385C5.82523 27.9749 5.41197 27.8811 5.02537 27.7358C3.09236 26.9563 2.15919 24.7631 2.94572 22.8619L12.7041 5.9109C13.0374 5.31504 13.5439 4.80109 14.1705 4.47079ZM15.9969 20.3635C15.357 20.3635 14.8237 20.892 14.8237 21.5275C14.8237 22.1603 15.357 22.6901 15.9969 22.6901C16.6367 22.6901 17.1567 22.1603 17.1567 21.5129C17.1567 20.8801 16.6367 20.3635 15.9969 20.3635ZM15.9969 12.1205C15.357 12.1205 14.8237 12.6345 14.8237 13.27V17.0076C14.8237 17.6418 15.357 18.1716 15.9969 18.1716C16.6367 18.1716 17.1567 17.6418 17.1567 17.0076V13.27C17.1567 12.6345 16.6367 12.1205 15.9969 12.1205Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcn);
export default __webpack_public_path__ + "static/media/errorIcn.9b9f81cd007067657c1c13940fed08fc.svg";
export { ForwardRef as ReactComponent };